import React, { useState, useEffect, useReducer, useCallback, useMemo } from "react";
import APIService from "../../Services/API/APIService";
import {
  Table,
  Dimmer,
  Loader,
  Dropdown,
  Menu,
  Form,
  Modal,
  Label,
  Pagination
} from "semantic-ui-react";
import dayjs from "dayjs";
import numeral from "numeral";
import { toast } from "react-toastify";
import PaystackDetails from "./PaystackDetails";
import AuditTrails from "./AuditTrails";
import { sortReducer } from "../../utils/SortReducer";
import ProductTypes from "../../Data/ProductTypes";


const CompletedBookings = (props) => {

  const [loading, setLoading] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState(null);
  const [selectedAudit, setSelectedAudit] = useState(null);
  const [response, setResponse] = useState(null)
  const [paystackModalState, togglePaystackModal] = useState(false);
  const [auditModalState, toggleAuditModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(50);
  const [rowCount, setRowCount] = useState(0);
  const [orderTotal, setOrderTotal] = useState([])
  const [payout, setPayout] = useState([])
  const [state, dispatch] = useReducer(sortReducer, {
    column: null,
    data: null,
    direction: null,
  });

  const { data } = state;

  let query = useMemo(() => {
    return {
      offset: offset,
      limit: limit,
    }
  }, [limit, offset])
  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(true);
      let result = await APIService.getData("/guest-house/getCompletedBooking", {
        ...query
      }
      );

      dispatch({
        type: "",
        column: "",
        payload: result.bookings,
      });

      if (isSubscribed) {
        setRowCount(result.count)
        setOrderTotal(result.orderTotal)

      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [query])

  useEffect(() => {
    let isSubscribed = true;

    fetchData(isSubscribed);
    return () => (isSubscribed = false);
  }, [offset, fetchData]);

  const _searchChanged = (e) => {
    setSearchPhrase(e.target.value);
  };


  const checkPayment = async (item, mode) => {
    try {
      if (item.GuestHousePayment?.[`${mode}paymentMode`] === "DIRECT_TRANSFER") {
        setLoading(true);
        let response = await APIService.postData(
          `/checkout/checkPayment`,
          { GuestHousePaymentId: item.GuestHousePaymentId, mode: mode }
        );
        var win = window.open(response?.location, "_blank");
        win.focus();

        setLoading(false);
      } else if (item.GuestHousePayment?.[`${mode}paymentMode`] === "PAYSTACK") {
        try {
          setLoading(true);

          let response = await APIService.getData(
            `/checkout/verifyPaystackPayment/`,
            { reference: mode === 'checkin' ? item.GuestHousePayment?.payReference : item.GuestHousePayment?.checkoutpayReference }
          );
          let payout = await APIService.getData("/checkout/getAllPayout", {

          }
          );

          setPayout(payout)
          setResponse(response)
          togglePaystackModal(true)
          setLoading(false);

        } catch (error) {
          toast.error("Error completing action");
          setLoading(false);
        }

      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };



  const openAuditModal = async (audit) => {
    try {
      setSelectedAudit(audit);
      toggleAuditModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };
  const _search = async () => {
    setLoading(true);
    try {
      let result = [];
      if (searchPhrase) {
        let searchPhrases = searchPhrase.trimStart()
        result = await APIService.getData(`/guest-house/searchPastBookings`,
          {
            bookingId: searchPhrases
          }
        );
      }

      dispatch({
        type: "",
        column: "",
        payload: result.bookings,
      });

      setRowCount(result.count)
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };



  let counter = 0

  const bookingItems = data?.map((item) => (

    <Table.Row key={item.id}>

      <Table.Cell> {counter = counter + 1}</Table.Cell>
      <Table.Cell>{item.bookingId}</Table.Cell>
      <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{item.GuestHousePackage?.name}</Table.Cell>
      <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.firstname + "  " + item.GuestHouseUser?.lastname :
        item.GuestHouseSecretUser?.firstname + " " + item.GuestHouseSecretUser?.lastname}</Table.Cell>
      <Table.Cell>{dayjs(item.checkin).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{dayjs(item.checkout).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{item.nights}</Table.Cell>
      <Table.Cell>
        ₦{numeral(item.GuestHousePackage?.price).format("0,0")}
      </Table.Cell>

      <Table.Cell>
        ₦{numeral(item.GuestHousePayment?.discountAmount).format("0,0")}
      </Table.Cell>
      <Table.Cell>
        ₦{numeral(item.total).format("0,0")}
      </Table.Cell>


      <Table.Cell>
        ₦
        {
          numeral(orderTotal.filter((e) => Number(e.GuestHouseBookingId) === Number(item?.id))[0]?.order_total).format("0,0")

        }
      </Table.Cell>
      <Table.Cell>
        ₦{typeof (orderTotal.filter((e) => Number(e.GuestHouseBookingId) === Number(item?.id))[0]?.order_total) == 'number' ?
          numeral(orderTotal.filter((e) => Number(e.GuestHouseBookingId) === Number(item?.id))[0]?.order_total + item.total).format("0,0")
          : numeral(item.total).format("0,0")}
      </Table.Cell>

      <Table.Cell>
        ₦{numeral(item.GuestHousePayment?.refund).format("0,0")}
      </Table.Cell>
      <Table.Cell>      <Label
        onClick={() => checkPayment(item, 'checkin')}
        color={
          item.GuestHousePayment?.checkinpaymentMode === "POS"
            ? "teal"
            : item.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER"
              ? "violet"
              : item.GuestHousePayment?.checkinpaymentMode === "PAYSTACK"
                ? "olive"
                : item.GuestHousePayment?.checkinpaymentMode === "COOP_SAVINGS"
                  ? "purple"
                  : item.GuestHousePayment?.checkinpaymentMode === "COOP_DEBIT"
                    ? "green"
                    : "brown"
        }
      >
        {item.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER" ? "TRANSFER" : item.GuestHousePayment?.checkinpaymentMode || "N/A"}
      </Label></Table.Cell>
      <Table.Cell>

        {item.GuestHousePayment?.checkinpaymentMode === 'DIRECT_TRANSFER' || item.GuestHousePayment?.checkinpaymentMode === 'PAYSTACK' ?
          (
            <Label color={
              item?.checkinPayment === true ? "teal" : 'red'
            }>
              {item?.checkinPayment === true ? "Yes" : 'No'}
            </Label>
          )
          :

          (<Label color="brown">
            N/A
          </Label>)


        }

      </Table.Cell>

      <Table.Cell>      <Label
        onClick={() => checkPayment(item, 'checkout')}
        color={
          item.GuestHousePayment?.checkoutpaymentMode === "POS"
            ? "teal"
            : item.GuestHousePayment?.checkoutpaymentMode === "DIRECT_TRANSFER"
              ? "violet"
              : item.GuestHousePayment?.checkoutpaymentMode === "PAYSTACK"
                ? "olive"
                : item.GuestHousePayment?.checkoutpaymentMode === "COOP_SAVINGS"
                  ? "purple"
                  : item.GuestHousePayment?.checkoutpaymentMode === "COOP_DEBIT"
                    ? "green"
                    : "brown"
        }
      >
        {item.GuestHousePayment?.checkoutpaymentMode === "DIRECT_TRANSFER" ? "TRANSFER" : item.GuestHousePayment?.checkoutpaymentMode || "N/A"}
      </Label></Table.Cell>

      <Table.Cell>

        {item.GuestHousePayment?.checkoutpaymentMode === 'DIRECT_TRANSFER' || item.GuestHousePayment?.checkoutpaymentMode === 'PAYSTACK' ?
          (
            <Label color={
              item?.checkoutPayment === true ? "teal" : 'red'
            }>
              {item?.checkoutPayment === true ? "Yes" : 'No'}
            </Label>
          )
          :

          (<Label color="brown">
            N/A
          </Label>)


        }

      </Table.Cell>
      <Table.Cell>
        <Label
          color={
            item.status === "COMPLETED"
              ? "teal"
              : "brown"
          }
        >
          {item.status}
        </Label>
      </Table.Cell>
      <Table.Cell>
        <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
          <Dropdown.Menu>

            {(item.status !== "RESERVED") && (
              <Dropdown.Item
                icon="tasks"
                text="View Audit Trails"
                onClick={() => openAuditModal(item)}
              />
            )}
          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>

    </Table.Row>
  ));
  return (

    <div style={{ overflowX: 'auto' }}>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}


      <Menu secondary stackable>


        <Menu.Menu position="right">
          <Menu.Item>
            <Form>
              <Form.Input
                placeholder="Firstname or lastname"
                icon="search"
                onChange={_searchChanged}
                action={{
                  onClick: _search,
                  color: 'teal'
                }}

              />
            </Form>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      {data && (
        <div>
        <Table basic striped celled compact size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S/N</Table.HeaderCell>
              <Table.HeaderCell>Booking ID</Table.HeaderCell>
              <Table.HeaderCell>Booked Date</Table.HeaderCell>
              <Table.HeaderCell>Package</Table.HeaderCell>
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Check In</Table.HeaderCell>
              <Table.HeaderCell>Check Out</Table.HeaderCell>
              <Table.HeaderCell>Nights</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Discount</Table.HeaderCell>
              <Table.HeaderCell>Paid</Table.HeaderCell>
              <Table.HeaderCell>Orders Total</Table.HeaderCell>
              <Table.HeaderCell>Customer Total</Table.HeaderCell>
              <Table.HeaderCell>Refund</Table.HeaderCell>
              <Table.HeaderCell>Check In Payment</Table.HeaderCell>
              <Table.HeaderCell>Verified</Table.HeaderCell>
              <Table.HeaderCell>Check Out Payment</Table.HeaderCell>
              <Table.HeaderCell>Verified</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{bookingItems}</Table.Body>
        </Table>
        </div>
      )}


      <Pagination
        defaultActivePage={1}
        totalPages={Math.ceil(rowCount / limit)}
        onPageChange={(e, { activePage }) =>
          setOffset(1 + (activePage - 1) * limit)
        }
      />


      <Modal
        size="small"
        open={paystackModalState}
        onClose={() => togglePaystackModal(false)}
        closeIcon
      >
        <Modal.Header>Paystack Details</Modal.Header>
        <Modal.Content>

          <PaystackDetails receipt={response} payout={payout} />
        </Modal.Content>
      </Modal>


      <Modal
        size="small"
        open={auditModalState}
        onClose={() => toggleAuditModal(false)}
        closeIcon
      >
        <Modal.Header>Audit Trails</Modal.Header>
        <Modal.Content>
          <AuditTrails audit={selectedAudit} />
        </Modal.Content>
      </Modal>

    </div>


  );
};

export default CompletedBookings;
